import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';

const useChangeEvaluationStatus = () => {
  const [isLoading, setIsLoading] = useState(false);

  const changeStatus = useCallback(
    async ({ procurementId, newStatus = 3, onSuccess }) => {
      if (!procurementId) return false;

      const token = getAuthToken();
      if (!token) {
        toast.error('Authentication required. Please login again.');
        return false;
      }

      setIsLoading(true);
      try {
        await axios.post(
          `${api.API_URL}/procurement/change-evaluation-status`,
          { procurementId, newStatus },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success('Tender evaluation status updated successfully.');
        onSuccess?.();
        return true;
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          'Failed to update tender evaluation status';
        toast.error(message);
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { changeStatus, isLoading };
};

export default useChangeEvaluationStatus;
